// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import { MediaItemValue, Feature } from '@fulcrumapp/fulcrum-core';
import Immutable from 'immutable';
import MapView from '../../data-view/map/map-view';
import { AppContext } from '../../hooks/use-app';

const DEFAULT_ZOOM = 16;

export default class PhotoMapView extends React.Component {
  static propTypes = {
    className: PropTypes.string.isRequired,
    item: PropTypes.instanceOf(MediaItemValue).isRequired,
    feature: PropTypes.instanceOf(Feature),
    visible: PropTypes.bool.isRequired,
    metadata: PropTypes.instanceOf(Object),
  };

  static contextType = AppContext;

  constructor(props) {
    super(props);

    let center = null;

    if (props.metadata
        && props.metadata.latitude != null && props.metadata.longitude != null
        && props.metadata.latitude !== 0 && props.metadata.longitude !== 0) {
      center = [props.metadata.latitude,
        props.metadata.longitude];
    }

    this.state = {
      center,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const metadataChanged = nextProps.metadata && this.props.metadata !== nextProps.metadata;

    if (metadataChanged) {
      if (nextProps.metadata.latitude != null && nextProps.metadata.latitude !== 0
          && nextProps.metadata.longitude != null && nextProps.metadata.longitude !== 0) {
        this.setState({
          center: [nextProps.metadata.latitude,
            nextProps.metadata.longitude],
        });
      }
    }
  }

  bindMapView = (node) => {
    this.mapView = node;
  };

  render() {
    const { styles } = PhotoMapView;

    const circles = [];

    if (this.props.feature && this.props.feature.hasCoordinate) {
      circles.push({
        data: { feature: this.props.feature, parent: true },
        color: '#3F51B5',
        location: { lat: this.props.feature.latitude, lng: this.props.feature.longitude },
      });
    }

    let zoom = 3;

    let currentViewPoint = null;

    if (this.props.metadata
        && this.props.metadata.latitude != null && this.props.metadata.longitude != null
        && this.props.metadata.latitude !== 0 && this.props.metadata.longitude !== 0) {
      const point = { lat: this.props.metadata.latitude, lng: this.props.metadata.longitude };

      zoom = DEFAULT_ZOOM;

      circles.push({
        data: { item: this.props.item },
        color: null,
        location: point,
      });

      if (this.props.metadata.exif && this.props.metadata.exif.gps_img_direction != null) {
        const angle = +this.props.metadata.exif.gps_img_direction;

        currentViewPoint = { viewportAngle: angle, location: point };
      }
    }

    const circleList = new Immutable.List(Immutable.fromJS(circles));

    return (
      <div className={cx(this.props.className, styles.container)}>
        <MapView
          ref={this.bindMapView}
          parentView="media-viewer"
          className={styles.map}
          visible={this.props.visible}
          center={this.state.center}
          zoom={zoom}
          currentViewPoint={currentViewPoint}
          circleMarkers={circleList}
          showExtentsControl={false}
          showGeocoderControl={false}
        />
      </div>
    );
  }
}

const styles = cssInJS({
  container: {
    borderLeft: '1px solid #aaa',

    '@phone': {
      borderLeft: 'none',
      borderTop: '1px solid #d9d9d9',
      borderBottom: '1px solid #d9d9d9',
    },
  },

  map: {
    width: '100%',
    height: '100%',
  },
});

PhotoMapView.styles = styles;
